import { fetchOneEntry } from '@builder.io/sdk-vue';

export function fetchPage(urlPath: string) {
    return fetchOneEntry({
        model: import.meta.env.MIX_BUILDER_IO_PAGE_MODEL,
        apiKey: import.meta.env.MIX_BUILDER_IO_API_KEY,
        userAttributes: { urlPath },
    });
}
